import React from 'react';
import styles from './ProgressBar.module.css';

const ProgressBar = ({ progress }) => {
  return (
    <div className={`d-flex align-items-center gap-2 ${styles.progressWrapper}`}>
    <div className={styles.progressContainer}>
      <div 
        className={styles.progressBar} 
        style={{ width: `${progress}%` }}
      >
        
      </div>
    </div>
    <span className={styles.progressText}>{progress}%</span>
    </div>
  );
};

export default ProgressBar;